import React, {Component} from 'react';
import classNames from 'classnames';
import SliderDotMark from './SliderDotMark';
import DifferentialSlider from './DifferentialSlider';

const handlesNotMoved = (event, prev) => (event[0] === prev[0] && event[1] === prev[1]);

const leftHandleMoved = (event, prev) => (event[0] !== prev[0] && event[1] === prev[1]) || (event[0] !== prev[1] && event[1] === prev[0]);

const rightHandleMoved = (event, prev) => (event[0] === prev[0] && event[1] !== prev[1]) || (event[0] === prev[1] && event[1] !== prev[0]);

class SliderWidget extends Component {
    constructor(props) {
        super(props);
        const {origin} = props;

        this.state = {
            value: null,
            range: [origin, origin],
            previousEvent: [origin, origin],
            pristine: true,
            dragging: false,
        };
        this.onChange = this.onChange.bind(this);
        this.onChangeComplete = this.onChangeComplete.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.origin !== prevProps.origin) {
            const {origin} = this.props;
            this.setState({
                value: null,
                range: [origin, origin],
                previousEvent: [origin, origin],
            });
        }
    }

    async onChange(e) {
        const {origin} = this.props;
        const {range, value, previousEvent, dragging} = this.state;

        // dragging and same event no change
        if (dragging && e[0] === previousEvent[0] && e[1] === previousEvent[1]) {
            return;
        }

        let newRange = e;

        if (handlesNotMoved(e, range)) {
            newRange = e[1] === value ? [e[0], origin] : [origin, e[1]];
        } else if (leftHandleMoved(e, range)) {
            newRange = dragging && e[1] === origin && previousEvent[1] !== origin? // dragging towards origin
                [origin, origin]:
                e[0] >= origin ? [origin, e[0]] : [e[0], origin];
        } else if (rightHandleMoved(e, range)) {
            newRange = dragging && e[0] === origin && previousEvent[0] !== origin? // dragging towards origin
                [origin, origin]:
                e[1] <= origin ? [e[1], origin] : [origin, e[1]];
        } else { // both handles moved. check previous event
            if (leftHandleMoved(e, previousEvent)) {
                newRange = e[0] >= origin ? [origin, e[0]] : [e[0], origin];
            } else if (rightHandleMoved(e, previousEvent)) {
                newRange = e[1] <= origin ? [e[1], origin] : [origin, e[1]];
            }
        }

        const newValue = newRange[0] !== origin ? newRange[0] : (newRange[1] !== origin ? newRange[1] : origin);

        await this.setState({
            range: newRange,
            value: newValue,
            previousEvent: e,
            pristine: false,
            dragging: true,
        });

        this.props.onChange(newValue);
    }

    onChangeComplete(e) {
        console.log(`complete: ${e}`);
        this.setState({
            dragging: false,
        });
    }

    handleClick(value) {
        const {origin} = this.props;
        if (this.state.pristine || value === origin) {
            this.onChange([origin, origin]);
        }
    }

    render() {
        const marks = {};

        for (let i = this.props.min; i < this.props.max + this.props.step; i += this.props.step) {
            marks[i.toString()] = <SliderDotMark />;
        }

        return (
            <div className={classNames('row slider', {'nv-slider__pristine': this.state.pristine})}>
                <div className="col-sm-8 col-12">
                    <DifferentialSlider
                        min={this.props.min}
                        max={this.props.max}
                        value={this.state.range}
                        step={this.props.step}
                        onChange={this.onChange}
                        onChangeComplete={this.onChangeComplete}
                        allowCross={true}
                        marks={marks}
                        dots={this.props.dots}
                        className={classNames('rc-slider-left-right-handle')}
                        origin={this.props.origin}
                        handleClick={this.handleClick}
                    />
                </div>
                <div className={classNames('col-sm-2 col-4 order-sm-first mt-3 mt-sm-0 text-center label',
                    {active: this.state.value && this.state.value < this.props.origin})}>
                    {this.props.minLabel}
                </div>
                <div className={classNames('col-sm-2 col-4 offset-sm-0 offset-4 mt-3 mt-sm-0 text-center label',
                    {active: this.state.value && this.state.value > this.props.origin})}>
                    {this.props.maxLabel}
                </div>
            </div>
        );
    }
}

export default SliderWidget;
